import React from 'react';
import { compose } from 'redux';
import { ShopItemType } from '../../../../../types/shop';
import withSectionFetchSpinner from '../../../../decorators/withSectionFetchSpinner';
import ShopGrid from '../ShopGrid';
import PremiumContentEmptyState from '../_partials/PremiumContentEmptyState';
import s from '../ShopSection.scss';

export interface Props {
  className?: string;
}

const enhance = compose(withSectionFetchSpinner);
export class ShopPremiumContent extends React.Component<Props> {
  render() {
    const { className } = this.props;

    return (
      <div className={s['section-with-no-header']}>
        <ShopGrid
          className={className}
          itemType={ShopItemType.PREMIUM_CONTENT}
          emptyState={<PremiumContentEmptyState view={'large'} />}
        />
      </div>
    );
  }
}

export default enhance(ShopPremiumContent) as React.ComponentType<Props>;
